import { z } from "zod";
const isoDateTime = z.string().datetime({ offset: false, message: "must be ISO-8601 UTC, e.g. 2026-05-01T13:30:00.000Z" });
const optionalGoogleMapLink = z
    .union([z.string().url(), z.literal(""), z.null()])
    .optional()
    .transform((v) => (v && v.length > 0 ? v : null));
// Raw shapes are exported so MCP tools (and other extenders) can compose them
// into larger input objects without losing field-level types. The refined
// schemas used by HTTP controllers add cross-field invariants on top.
export const timelineItemUploadShape = {
    title: z.string().trim().min(1, "title required"),
    description: z.string().optional().default(""),
    startDate: isoDateTime,
    endDate: isoDateTime,
    googleMapLink: optionalGoogleMapLink,
};
export const TimelineItemUploadSchema = z
    .object(timelineItemUploadShape)
    .refine((v) => Date.parse(v.endDate) >= Date.parse(v.startDate), {
    message: "endDate must be on or after startDate",
    path: ["endDate"],
});
export const PlanUploadSchema = z.object({
    title: z.string().trim().min(1, "title required"),
    timeline: z.array(TimelineItemUploadSchema).min(1, "timeline must have at least one item"),
});
export const ItemCreateSchema = TimelineItemUploadSchema;
export const itemUpdateShape = {
    title: z.string().trim().min(1).optional(),
    description: z.string().optional(),
    startDate: isoDateTime.optional(),
    endDate: isoDateTime.optional(),
    googleMapLink: optionalGoogleMapLink,
};
export const ItemUpdateSchema = z
    .object(itemUpdateShape)
    .refine((v) => {
    if (v.startDate && v.endDate) {
        return Date.parse(v.endDate) >= Date.parse(v.startDate);
    }
    return true;
}, { message: "endDate must be on or after startDate", path: ["endDate"] });
export const ItemsBatchAddSchema = z.object({
    items: z.array(TimelineItemUploadSchema).min(1, "items must have at least one entry"),
});
export const ItemBatchEditEntrySchema = z
    .object({
    id: z.string().trim().min(1, "id required"),
    title: z.string().trim().min(1).optional(),
    description: z.string().optional(),
    startDate: isoDateTime.optional(),
    endDate: isoDateTime.optional(),
    googleMapLink: optionalGoogleMapLink,
})
    .refine((v) => {
    if (v.startDate && v.endDate) {
        return Date.parse(v.endDate) >= Date.parse(v.startDate);
    }
    return true;
}, { message: "endDate must be on or after startDate", path: ["endDate"] });
export const ItemsBatchEditSchema = z.object({
    items: z.array(ItemBatchEditEntrySchema).min(1, "items must have at least one entry"),
});
export const PlanUpdateSchema = z.object({
    title: z.string().trim().min(1),
});
export const CommentCreateSchema = z.object({
    body: z.string().trim().min(1).max(2000),
});
const emailField = z.string().trim().toLowerCase().email("invalid email");
export const SignupSchema = z.object({
    email: emailField,
    password: z.string().min(8, "password must be at least 8 characters").max(200),
    name: z.string().trim().min(1, "name required").max(40),
});
export const LoginSchema = z.object({
    email: emailField,
    password: z.string().min(1).max(200),
});
export const InviteMemberSchema = z.object({
    email: emailField,
});
export const CreateApiTokenSchema = z.object({
    label: z.string().trim().max(60).optional().default(""),
});
//# sourceMappingURL=schemas.js.map